import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import InformationModal from '../../common/InformationModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as informationActions from '../../actions/InformationItems'
import * as Constants from '../../../helpers/Constants'

class NewInformationItemModal extends Component {
  state = {
    titleInput: '',
    errorTitle: '',
    titleEnglishInput: '',
    informationInput: '',
    errorInformation: '',
    informationEnglishInput: '',
    errorMessage: '',
    type: Constants.PHONE
  }

  componentWillReceiveProps(nextProps) {
    const { informationItems } = this.props

    if (
      !nextProps.informationItems.isCreating &&
      nextProps.informationItems.errorCreating === null &&
      informationItems.isCreating
    ) {
      this.props.hideCreateInformationItemModal()
      this.props.showSnackbar(Strings.default.INFORMATION_CREATED)
      this.resetFields()
    } else if (
      !nextProps.informationItems.isCreating &&
      nextProps.informationItems.errorCreating !== null &&
      informationItems.isCreating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  createInformation() {
    const { data, user } = this.props
    const {
      titleInput,
      titleEnglishInput,
      informationInput,
      informationEnglishInput,
      type
    } = this.state

    this.setState({ errorMessage: '' })

    if (titleInput === '') {
      this.setState({ errorTitle: Strings.default.MANDATORY_FIELD })
    }

    if (informationInput === '') {
      this.setState({ errorInformation: Strings.default.MANDATORY_FIELD })
    }

    // Add checks if english
    if (titleInput !== '' && informationInput !== '') {
      const postData = {
        title: titleInput,
        titleEN: titleEnglishInput === '' ? titleInput : titleEnglishInput,
        information: informationInput,
        informationEN:
          informationEnglishInput === '' || type !== Constants.TEXT
            ? informationInput
            : informationEnglishInput,
        type,
        sort: 0
      }

      this.props.tryCreateInformationItem(
        user.token,
        data.community.id,
        postData
      )
    }
  }

  resetFields() {
    this.setState({
      titleInput: '',
      errorTitle: '',
      titleEnglishInput: '',
      informationInput: '',
      errorInformation: '',
      informationEnglishInput: '',
      errorMessage: '',
      type: Constants.PHONE
    })
  }

  render() {
    const { config, informationItems } = this.props
    const {
      titleInput,
      errorTitle,
      titleEnglishInput,
      informationInput,
      errorInformation,
      informationEnglishInput,
      errorMessage,
      type
    } = this.state

    return (
      <InformationModal
        show={config.createInformationItemModal.show}
        hide={() => {
          this.resetFields()
          this.props.hideCreateInformationItemModal()
        }}
        titleInput={titleInput}
        errorTitle={errorTitle}
        onChangeTitle={text =>
          this.setState({
            titleInput: text,
            errorTitle: '',
            errorMessage: ''
          })
        }
        titleEnglishInput={titleEnglishInput}
        onChangeTitleEnglish={text =>
          this.setState({
            titleEnglishInput: text,
            errorMessage: ''
          })
        }
        informationInput={informationInput}
        errorInformation={errorInformation}
        onChangeInformation={text =>
          this.setState({
            informationInput: text,
            errorInformation: '',
            errorMessage: ''
          })
        }
        informationEnglishInput={informationEnglishInput}
        onChangeInformationEnglish={text =>
          this.setState({
            informationEnglishInput: text,
            errorMessage: ''
          })
        }
        header={Strings.default.CREATE_INFORMATION}
        information={Strings.default.CREATE_INFORMATION_INFO}
        onDone={() => this.createInformation()}
        loading={informationItems.isCreating}
        type={type}
        onChangeType={newType => this.setState({ type: newType })}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, informationItems }) {
  return { config, data, user, informationItems }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...informationActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewInformationItemModal)



// WEBPACK FOOTER //
// ./src/components/containers/NewInformationItemModal/index.js